export interface Coordinates {
  lat: number;
  lng: number;
}

interface NavigationApp {
  name: string;
  icon: string;
  getUrl: (
    userLocation: Coordinates,
    destination: Coordinates,
    destinationName: string
  ) => string;
}

export const navigationApps: NavigationApp[] = [
  {
    name: 'Google Maps',
    icon: '🗺️',
    getUrl: (userLocation, destination, destinationName) =>
      `https://www.google.com/maps/dir/?api=1&origin=${userLocation.lat},${userLocation.lng}&destination=${destination.lat},${destination.lng}&destination_place_id=${encodeURIComponent(destinationName)}`,
  },
  {
    name: 'Apple Maps',
    icon: '🍎',
    getUrl: (userLocation, destination, destinationName) =>
      `https://maps.apple.com/?saddr=${userLocation.lat},${userLocation.lng}&daddr=${destination.lat},${destination.lng}&dirflg=d&t=m`,
  },
  {
    name: 'Waze',
    icon: '🚗',
    getUrl: (userLocation, destination, destinationName) =>
      `https://waze.com/ul?ll=${destination.lat},${destination.lng}&navigate=yes&z=10`,
  },
];